import { render } from "./FindSymptoms.vue?vue&type=template&id=124bba2e&scoped=true"
import script from "./FindSymptoms.vue?vue&type=script&lang=js"
export * from "./FindSymptoms.vue?vue&type=script&lang=js"

import "./FindSymptoms.vue?vue&type=style&index=0&id=124bba2e&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124bba2e"]])

export default __exports__